/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const FigmaIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="FigmaIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.99976 10.5C4.39267 10.0439 4 9.3178 4 8.5C4 7.6822 4.39267 6.95612 4.99976 6.5C4.39267 6.04389 4 5.3178 4 4.5C4 3.11929 5.11929 2 6.5 2H10.5C11.8807 2 13 3.11929 13 4.5C13 5.3178 12.6073 6.04388 12.0002 6.5C12.6073 6.95611 13 7.6822 13 8.5C13 9.88071 11.8807 11 10.5 11C9.9372 11 9.41783 10.814 9 10.5002V12.5C9 13.8807 7.88071 15 6.5 15C5.11929 15 4 13.8807 4 12.5C4 11.6822 4.39267 10.9561 4.99976 10.5ZM8 3H6.5C5.67157 3 5 3.67157 5 4.5C5 5.32843 5.67157 6 6.5 6H8V3ZM6.5 7H8V10H6.5C5.67157 10 5 9.32843 5 8.5C5 7.67157 5.67157 7 6.5 7ZM6.5 11C5.67157 11 5 11.6716 5 12.5C5 13.3284 5.67157 14 6.5 14C7.32843 14 8 13.3284 8 12.5V11H6.5ZM9 8.5C9 7.67157 9.67157 7 10.5 7C11.3284 7 12 7.67157 12 8.5C12 9.32843 11.3284 10 10.5 10C9.67157 10 9 9.32843 9 8.5ZM12 4.5C12 5.32843 11.3284 6 10.5 6H9V3H10.5C11.3284 3 12 3.67157 12 4.5Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

FigmaIcon.category = 'General Icons';

FigmaIcon.iconSize = 16;
